<script>
import SettingsSection from '@/components/advancedSettings/SettingsSection.vue'
import StackIndex from '@/assets/helpImages/StackIndex.png'

export default {
  name: 'StackIndex',
  components: { SettingsSection },
  props: ['value'],
  emits: ['input'],

  data() {
    return {
      StackIndex: StackIndex,
    }
  },
}
</script>

<template>
  <settings-section
    :value="value"
    label="Stack index"
    hint-title="Stack index"
    @input="$emit('input', $event)"
  >
    <template #content>
      <div class="content">
        <table>
          <tr>
            <td class="left-column">
              <p>
                <b>Stack Index</b>
              </p>
              <p>
                The stack index is a number which decides which product can be
                stacked on top of each other. The smallest index is stacked on
                top, the largest index on the bottom.
              </p>
              <p>Example:</p>
              <ul>
                <li>
                  Big and heavy products will get SI9 to be stacked on the
                  bottom.
                </li>
                <li>
                  Medium products will get SI7 to be stacked in the middle.
                </li>
                <li>
                  Small and light products will get SI3 to be stacked on the
                  top.
                </li>
              </ul>
            </td>
            <td class="right-column">
              <img :src="StackIndex" alt="Image Description" class="imgSize" />
            </td>
          </tr>
        </table>
      </div>
    </template>
  </settings-section>
</template>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
td {
  border: 1px solid black;
}
.left-column {
  width: 100%;
  background-color: white;
  padding: 2rem;
}
.right-column {
  width: 100%;
  text-align: center;
  background-color: white;
}

.imgSize {
  width: 500px;
}

.content {
  padding: 16px;
}
</style>
